import classNames from 'classnames'
import { PlatformKey } from 'platform-config'
import './FooterView.layout.scss'

export const FooterViewLayout = defineComponent({
  name: 'FooterViewLayout',
  inheritAttrs: false,
  setup(_, { slots, attrs }) {
    return () => (
      <div {...attrs} class={classNames('cloud-computing-power-footer-view-layout', { 'platform-bge': PlatformKey === 'bge' }, attrs.class as string)}>
        {slots.default?.()}
      </div>
    )
  },
})
